import { render, staticRenderFns } from "./AddKeyObjectives.vue?vue&type=template&id=3d5ec32f&scoped=true"
import script from "./AddKeyObjectives.vue?vue&type=script&lang=js"
export * from "./AddKeyObjectives.vue?vue&type=script&lang=js"
import style0 from "./AddKeyObjectives.vue?vue&type=style&index=0&id=3d5ec32f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ec32f",
  null
  
)

export default component.exports